import { Modal } from "@/shared/ui";
import PlayerMenuSettingsSafetyDisableTfaEmailCheckContainer from "@/domains/playerMenu/containers/settings/safety/tfa/check-disable/PlayerMenuSettingsSafetyDisableTfaEmailCheckContainer";

type Props = {
  onClose: () => void;
};

export default function PlayerMenuSettingsSafetyDisableTfaEmailContainer({ onClose }: Props) {
  return (
    <Modal open onClose={onClose} title="Отключение 2FA Email" className="h-[49rem]">
      <PlayerMenuSettingsSafetyDisableTfaEmailCheckContainer onClose={onClose} />
    </Modal>
  );
}
